import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Search,
    Filter,
    Plus,
    Download,
    MoreHorizontal,
    Mail,
    Phone,
    Shield,
    Trash2,
    Edit2
} from 'lucide-react';

export default function StudentList() {
    const [selectedGrade, setSelectedGrade] = useState('All Grades');

    const studentsData = [
        { sn: '01', id: 101, name: 'Alice Thompson', grade: 'Grade 10A', parent: 'Robert Thompson', fees: 'Paid', status: 'Active' },
        { sn: '02', id: 105, name: 'David Brown', grade: 'Grade 10B', parent: 'Wilson Brown', fees: 'Pending', status: 'Active' },
        { sn: '03', id: 102, name: 'John Doe', grade: 'Grade 9C', parent: 'Jane Doe', fees: 'Late', status: 'Active' },
        { sn: '04', id: 103, name: 'Michael Smith', grade: 'Grade 10A', parent: 'Sarah Smith', fees: 'Paid', status: 'Inactive' },
        { sn: '05', id: 104, name: 'Sarah Wilson', grade: 'Grade 11B', parent: 'Chris Wilson', fees: 'Paid', status: 'Active' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Student Directory"
                    subtitle="Manage and oversee all student records across the institution"
                >
                    <div className="relative group">
                        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                        <input
                            type="text"
                            placeholder="UID, Name or Grade..."
                            className="pl-11 pr-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all w-64"
                        />
                    </div>

                    <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                        <Download size={18} className="text-gray-400" />
                        CSV
                    </button>

                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Add New
                    </button>
                </Header>

                {/* Filter Bar */}
                <div className="flex items-center gap-3 mb-8">
                    {['All Grades', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'].map(g => (
                        <button
                            key={g}
                            onClick={() => setSelectedGrade(g)}
                            className={`px-5 py-2 rounded-full text-[13px] font-black transition-all ${selectedGrade === g ? 'bg-blue-500 text-white shadow-lg shadow-blue-200' : 'bg-white border border-gray-100 text-gray-500 hover:border-gray-300'}`}

                        >
                            {g}
                        </button>
                    ))}
                </div>

                {/* Table Section */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">Academic Census</h3>
                            <div className="flex items-center gap-2">
                                <span className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></span>
                                <span className="text-gray-400 font-bold text-[14px]">1,280 Total Students</span>
                            </div>
                        </div>
                        <button className="p-1.5 text-gray-400 hover:text-gray-900"><MoreHorizontal size={22} /></button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Info</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Class</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Guardian</th>
                                    <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Fees Status</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                    <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {studentsData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5">
                                            <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center font-black group-hover:scale-105 transition-transform overflow-hidden">
                                                    <img src={`https://api.dicebear.com/7.x/initials/svg?seed=${v.name}`} alt="" />
                                                </div>
                                                <div>
                                                    <p className="text-[15px] font-black text-[#111827] mb-0.5">{v.name}</p>
                                                    <p className="text-[12px] font-bold text-gray-400 uppercase tracking-tighter">UID: SCT-{v.id}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-center">
                                            <span className="px-3 py-1 bg-slate-50 border border-gray-100 rounded-lg text-[13px] font-black text-gray-600">{v.grade}</span>
                                        </td>
                                        <td className="px-6 py-5">
                                            <p className="text-[14px] font-bold text-gray-700">{v.parent}</p>
                                            <p className="text-[11px] font-bold text-blue-500 cursor-pointer hover:underline">View Contact</p>
                                        </td>
                                        <td className="px-6 py-5 text-center">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg uppercase tracking-widest ${v.fees === 'Paid' ? 'text-emerald-500 bg-emerald-50' :
                                                v.fees === 'Late' ? 'text-rose-500 bg-rose-50' : 'text-amber-500 bg-amber-50'
                                                }`}>
                                                {v.fees}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-center">
                                            <div className={`w-2.5 h-2.5 rounded-full mx-auto ${v.status === 'Active' ? 'bg-emerald-500' : 'bg-gray-300'}`}></div>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-1">
                                                <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all"><Edit2 size={16} /></button>
                                                <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all"><Shield size={16} /></button>
                                                <button className="p-2 text-gray-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all"><Trash2 size={16} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </main>
        </div>
    );
}
